

export const items: any[] = [
    {
        id: '1',
        text: 'DASHBOARD',
        path: '/dashboard',
        enabled: true
    },
    {
        id: '2',
        text: 'DONOR LIST',
        path: '/donor-list',
        enabled: true
    },
    {
        id: '3',
        text: 'REPORTS',
        path: '/report',
        enabled: true
    }
];
